<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">告警管理</h1>
			<div class="clear marBottom20">
				<el-button type="" @click="fnClickAdd()"><i class="fa fa-plus"></i> 添加告警用户</el-button>
				<el-button type="" @click="clickDeleteBatch()">批量删除</el-button>
				<el-select class="ml20" @change="clickCom()" value-key="uid" v-if="administrators!=1 && administrators!=2" v-model="selectComId" placeholder="请选择公司">
					<el-option label="所有公司" key="-1" value=""></el-option>
		          <el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
		        </el-select>
		        <el-select class="ml20" v-model="selectAreaId" placeholder="请选择区域">
		          <el-option v-for="(area,index) in areaList" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
		        </el-select>
		        <el-button @click="getAlarmList()"> 查询 </el-button>
			</div>
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="alarmList"
			    tooltip-effect="dark"
			    @selection-change="handleSelectionChange"
			    style="width: 100%">
			    <el-table-column
			      type="selection"
			      width="55">
			    </el-table-column>
			    <el-table-column
			      prop="username"
			      label="账号">
			    </el-table-column>
			    <el-table-column
			      prop="real_name"
			      label="姓名">
			    </el-table-column>
			    <el-table-column
			      prop="group_name"
			      label="区域分组"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="alarm_road_info"
			      label="告警方式"
			      width="300px"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="status"
			      label="是否可用"
			      :formatter="ifActive3"
			      width="100">
			    </el-table-column>
			    <el-table-column
			      prop="updated_time"
			      label="更新时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
		          label="操作"
		          show-overflow-tooltip>
		          <template slot-scope="scope">
		          	<el-button type="text" size="small"
		                       @click="clickModify(scope.$index, scope.row)">编辑
		            </el-button>
		            <el-button type="text" size="small"
		                       @click="clickDelete(scope.$index, scope.row)">删除
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
	  			<br />
				<div class="text-right">
					<el-pagination
						@current-change="handleCurrentChange"
					  :page-size="pagesize"
					  layout="total, prev, pager, next"
					  :total="totalNum">
					</el-pagination>
				</div>
		</div>
		<!--删除确认框-->
		<el-dialog title="提示框" :visible.sync="deleteDialogFlag" width="500px" >
		    <div class="userInfo">
				<h4>删除后不可恢复，确认删除吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="deleteDialogFlag = false">取消</el-button>
			    <el-button type="primary" @click="confirmDelete()">确定</el-button>
			  </div>
		</el-dialog>
		<!--新增及编辑弹框-->
		<el-dialog :title="alarmDialogTitle" :visible.sync="alarmDialogFlag" width="600px" >
			<el-form>
				<!--编辑是显示-->
	          <el-form-item v-if="!ifAdd" label="账号：" :label-width="formLabelWidth">
	          	<span v-text="obEditAlarmUser.username"></span>
	          </el-form-item>
	          <!--新增时显示-->
	          <el-form-item v-if="ifAdd && administrators!=1 && administrators!=2" label="公司：" :label-width="formLabelWidth">
	          	<el-select @change="clickCom()" value-key="uid" v-model="selectComId" placeholder="请选择公司">
					<el-option label="所有公司" key="-1" value=""></el-option>
		          <el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
		        </el-select>
	          </el-form-item>
	          <el-form-item v-if="ifAdd" label="区域：" :label-width="formLabelWidth">
	          	<el-select @change="fnUnAlarmUserlist()" v-model="selectAreaId" placeholder="请选择区域">
		          <el-option v-for="(area,index) in areaList" v-if="area.group_name!='全部设备'" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
		        </el-select>
	          </el-form-item>
			  <el-form-item v-if="ifAdd" label="账号：" :label-width="formLabelWidth">
	          	<el-select v-if="ifAdd" v-model="obEditAlarmUser.user_id" placeholder="请选择用户">
		          <el-option v-for="unAlarmUser in unAlarmUserlist" :label="unAlarmUser.username + '('+ unAlarmUser.real_name + ')'" :key="unAlarmUser.uid" :value="unAlarmUser.uid"></el-option>
		        </el-select>
	          </el-form-item>
	          <!--公共部分-->
	          <el-form-item v-if="!ifAdd" label="姓名：" :label-width="formLabelWidth">
	          	<span v-text="obEditAlarmUser.real_name">无</span>
	          </el-form-item>
	          <el-form-item label="告警方式：" :label-width="formLabelWidth">
	          	<el-checkbox-group v-model="userAlarmRoads">
				    <el-checkbox v-for="(aItem) in alarmRoads" :label="aItem.id" :key="aItem.id">{{aItem.alarm_road}}</el-checkbox>
				  </el-checkbox-group>
	          </el-form-item>
	          <el-form-item label="勿扰模式" :label-width="formLabelWidth">
			      <el-time-picker
				    v-model="obEditAlarmUser.undisturbed_begin"
				    format="HH:mm"
				    value-format="timestamp"
				    placeholder="开始时间">
				  </el-time-picker>
				  <el-time-picker
				    v-model="obEditAlarmUser.undisturbed_end"
				    format="HH:mm"
				    value-format="timestamp"
				    placeholder="结束时间">
				  </el-time-picker>
			    </el-form-item>
	          
	          <el-form-item label="状态：" :label-width="formLabelWidth">
	            <el-radio-group v-model="obEditAlarmUser.status">
			      <el-radio :label="1">禁用</el-radio>
			      <el-radio :label="2">可用</el-radio>
			    </el-radio-group>
	          </el-form-item>
	        </el-form>

			  <div slot="footer" class="dialog-footer">
			    <el-button @click="alarmDialogFlag = false">取消</el-button>
			    <el-button type="primary" v-if="!ifAdd" @click="confirmModify()">确定</el-button>
			    <el-button type="primary" v-if="ifAdd" @click="confirmAddNewAlarmUser()">添加</el-button>
			  </div>
		</el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				if(this.administrators!=1 && this.administrators!=2){
					this.getCompanyList();
				}
				if(this.administrators==2){
					this.clickCom();
				}
				this.getAlarmList();
				this.getAlarmRoads();
				
		  	})
    	},
    	data(){
    		return{
    			alarmList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			comList:[],
    			selectComId:null,
    			selectCom:{},
    			selectAreaId:null,
    			areaList:[],
    			mac_address:"",
    			formLabelWidth:"120px",
    			unbindDevice:{},
    			showLoading:false,
    			administrators:this.getCookie('administrators'),
//  			多选时选中选项
    			multipleSelection:[],
//  			删除确认弹框是否显示
    			deleteDialogFlag: false,
//  			当前用户告警方式
    			userAlarmRoads:[],
//  			告警途径数组
    			alarmRoads:[],
    			alarmDialogTitle: "告警用户管理",
//  			分设置告警用户列表
    			unAlarmUserlist:[],
//  			是否添加新告警用户
    			ifAdd:false,
//  			告警弹框是否显示
    			alarmDialogFlag:false,
//  			编辑告警用户信息
				obEditAlarmUser:{
					username:"",
					real_name:"",
					alarm_road_info:"",
					alarm_roads:"",
					group_name:"",
					packet_id:"",
					status:1,
					user_id:null,
					undisturbed_begin:'',
					undisturbed_end:''
				}
    		}
    	},
    	methods:{
    		getAlarmList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
					mac_address:this.mac_address,
					company_id:this.selectComId || "",
					packet_id:this.selectAreaId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmGroup/AlarmGroupList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.alarmList = res.data.data.datalist || [];
		        			this.totalNum = res.data.data.totalNumber;
		        		}
		        		
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		this.mac_address = "";
		  		
			},
			handleSelectionChange(val){
				this.multipleSelection = val;
			},
			clickDelete(index,row){
				this.obEditAlarmUser = row;
				this.deleteDialogFlag = true;
			},
//			批量删除
			clickDeleteBatch(){
				if(this.multipleSelection.length>0){
					var obEditAlarmUserIdArr = [];
					for (let i = 0; i < this.multipleSelection.length; i++) {
						obEditAlarmUserIdArr.push(this.multipleSelection[i].id);
					}
					this.obEditAlarmUser.id = JSON.stringify(obEditAlarmUserIdArr).replace(/\[|]/g,'')
					this.deleteDialogFlag = true;
				}
				
			},
			confirmDelete(){
				let confirmDeleteParams={
					uid:this.getCookie('uid'),
					id:this.obEditAlarmUser.id,
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(confirmDeleteParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmGroup/AlarmGroupDelete",this.$qs.stringify(confirmDeleteParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.deleteDialogFlag = false;
		        	if(res.data.code==200){
		        		this.$message.success(res.data.msg);
		        		this.getAlarmList();
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			确认修改当前用户告警信息
			confirmModify(){
				let unAlarmUserlistParams={
					uid:this.getCookie('uid'),
					id:this.obEditAlarmUser.id,
					packet_id:this.obEditAlarmUser.packet_id,
					alarm_roads:JSON.stringify(this.userAlarmRoads).replace(/\[|]/g,''),
					status:this.obEditAlarmUser.status,
					undisturbed_begin:this.obEditAlarmUser.undisturbed_begin/1000,
					undisturbed_end:this.obEditAlarmUser.undisturbed_end/1000,
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(unAlarmUserlistParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmGroup/UpdateAlarmGroup",this.$qs.stringify(unAlarmUserlistParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.alarmDialogFlag = false;
		        	if(res.data.code==200){
		        		this.$message.success(res.data.msg);
		        		this.getAlarmList();
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			获取告警途径
			getAlarmRoads(){
				let unAlarmUserlistParams={
					uid:this.getCookie('uid'),
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(unAlarmUserlistParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmRoad/AlarmRoadShow",this.$qs.stringify(unAlarmUserlistParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.alarmRoads = res.data.data;
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			添加新的告警用户
			confirmAddNewAlarmUser(){
				
				let unAlarmUserlistParams={
					uid:this.getCookie('uid'),
					packet_id:this.selectAreaId || "",
					user_id:this.obEditAlarmUser.user_id,
					status:this.obEditAlarmUser.status,
					alarm_roads:JSON.stringify(this.userAlarmRoads).replace(/\[|]/g,''),
					undisturbed_begin:this.obEditAlarmUser.undisturbed_begin/1000,
					undisturbed_end:this.obEditAlarmUser.undisturbed_end/1000,
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(unAlarmUserlistParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmGroup/AddAlarmGroup",this.$qs.stringify(unAlarmUserlistParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.alarmDialogFlag = false;
		        	if(res.data.code==200){
		        		this.$message.success(res.data.msg);
		        		this.getAlarmList();
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			获取未设置告警用户列表
			fnUnAlarmUserlist(){
				if(this.administrators==2){
					this.selectComId = this.getCookie('company_id');
					
				}
				let unAlarmUserlistParams={
					uid:this.getCookie('uid'),
					packet_id:this.selectAreaId || "",
					company_id:this.selectComId || "",
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(unAlarmUserlistParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/UNAlarmUser/UNAlarmUser",this.$qs.stringify(unAlarmUserlistParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.unAlarmUserlist = res.data.data;
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			点击添加告警用户
			fnClickAdd(){
				this.selectAreaId = null;
				this.alarmDialogTitle = "添加告警用户";
				this.obEditAlarmUser={
					username:"",
					real_name:"",
					alarm_road_info:"",
					alarm_roads:"",
					group_name:"",
					packet_id:"",
					status:1,
					user_id:null,
					undisturbed_begin:'',
					undisturbed_end:''
				}
				this.userAlarmRoads = [];
				this.alarmDialogFlag = true;
				this.ifAdd = true;
			},
//			点击修改告警用户
			clickModify(index,row){
				this.alarmDialogTitle = "告警用户管理";
				this.alarmDialogFlag = true;
				this.obEditAlarmUser = row;
				this.ifAdd = false;
				if(row.alarm_roads==""){
					this.userAlarmRoads = [];
				}else{
					this.userAlarmRoads = row.alarm_roads.split(",").map(Number);
				}
//				处理时间戳显示不正确的问题
				if(this.obEditAlarmUser.undisturbed_begin<100000){
					this.obEditAlarmUser.undisturbed_begin = '';
				}else if(this.obEditAlarmUser.undisturbed_begin<10000000000){
					this.obEditAlarmUser.undisturbed_begin = this.obEditAlarmUser.undisturbed_begin*1000
				}
				if(this.obEditAlarmUser.undisturbed_end<100000){
					this.obEditAlarmUser.undisturbed_end = '';
				}else if(this.obEditAlarmUser.undisturbed_end<10000000000){
					this.obEditAlarmUser.undisturbed_end = this.obEditAlarmUser.undisturbed_end*1000
				}
				
			},
//			获取公司列表
			getCompanyList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:2,
		  			company_id:this.getCookie('company_id'),
		  			page:"1",
	  				pagesize:"9999",
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.comList = res.data.data.name || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			点击选择公司
			clickCom(){
//				点击公司后MAC地址设为空
				this.mac_address = "";
//				点击公司后赋值当前选中区域为空
				this.selectAreaId = null;
				//超级管理员和普通管理员分别管理
				if(this.administrators!=1 && this.administrators!=2){
					//点击赋值当前选中公司
					for(var i=0;i<this.comList.length;i++){
						if(this.comList[i].company_id == this.selectComId){
							this.selectCom = this.comList[i];
						}
					}	
				}else{
					this.selectCom.uid = this.getCookie('uid');
				}

				let valiCodeParams={
					uid:this.selectCom.uid || -1,
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PacketList/PacketList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		this.areaList = res.data.data
		        		
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getAlarmList();
			},
    	}
   }
</script>

<style>
	.search-box3{
		margin-top: -88px;
	}
</style>


// WEBPACK FOOTER //
// src/components/alarm/alarmList.vue